import BingAds from "../../../../contents/docs/cdp/sources/_snippets/source-bing-ads.mdx";
import * as React from 'react';
export default {
  BingAds,
  React
};